// Extract an Instagram reel/post ID from a URL and produce an embed iframe src.
// Examples supported:
//   https://www.instagram.com/reel/ABC123/...  → https://www.instagram.com/reel/ABC123/embed
//   https://www.instagram.com/p/ABC123/...     → https://www.instagram.com/p/ABC123/embed
//   https://www.instagram.com/tv/ABC123/...    → https://www.instagram.com/tv/ABC123/embed
export const toInstagramEmbed = (url) => {
  if (!url) return null;
  try {
    const m = url.match(/instagram\.com\/(reel|reels|p|tv)\/([A-Za-z0-9_-]+)/i);
    if (!m) return null;
    const kind = m[1] === "reels" ? "reel" : m[1];
    return `https://www.instagram.com/${kind}/${m[2]}/embed`;
  } catch { return null; }
};
